var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"counters"},[(_vm.getCurrentProject === 'mailru')?_c('MailCounters'):_vm._e(),_vm._v(" "),(_vm.getCurrentProject === 'mycom')?_c('MycomCounters'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }